import { apiPost, apiGet } from "../../utils/axios.js";
import apiEndpoints from "../../apiEndpoints.js";

export function getUserStats() {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.users.userStats())
            dispatch({
                type: 'USER_STATS_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            console.log(error);
        }
    }
}

export function getUserDetails(obj){
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.users.userDetails(), obj)
            if(response?.status === 200) {
                dispatch({
                    type: 'USER_DETAILS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'USER_DETAILS_SUCCESS',
                    payload: response.detail
                })
            }  
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetUserDetailsResponse() {
    return (dispatch) => {
        dispatch({
            type: "RESET_USER_DETAILS_RESPONSE"
        })
    }
}

export function getOrganizationByUser(url, type) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.organizations.organizationList()+url)
            if(response?.status === 200) {
                if(type === "list") {
                    dispatch({
                        type: 'ORGANIZATION_LIST_BY_USER_SUCCESS',
                        payload: response.data
                    })
                } else {
                    dispatch({
                        type: 'ASSIGNED_ORGANIZATION_LIST_BY_USER_SUCCESS',
                        payload: response.data
                    })
                }
                
            } else {
                dispatch({
                    type: 'ORGANIZATION_LIST_BY_USER_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetOrganizationListByUser() {
    return (dispatch) => {
        dispatch({
            type: "RESET_ORGANIZATION_LIST_BY_USER_SUCCESS"
        })
    }
}

export function inviteUserSingle(obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.users.inviteUserSingle(), obj)
            if(response?.status === 200) {
                dispatch({
                    type: 'INVITE_USER_SINGLE_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'INVITE_USER_SINGLE_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {

        }
    }
}

export function resetInviteUserResponse() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_INVITE_USER_RESPONSE'
        })
    }
}

export function editUser(obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.users.editUser(), obj)
            if(response?.status === 200) {
                dispatch({
                    type: 'EDIT_USER_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'EDIT_USER_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {

        }
    }
}

export function resetEditUserResponse () {
    return (dispatch) => {
        dispatch({
            type: "RESET_EDIT_USER_RESPONSE"
        })
    }
}

export function getUserSessionById(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.users.userSessionById()+url)
            if(response?.status === 200) {
                dispatch({
                    type: 'GET_USER_SESSION_BY_ID_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'GET_USER_SESSION_BY_ID_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {

        }
    }
}

export function deleteUserSingle(obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.users.deleteUserSingle(), obj)
            if(response?.status === 200) {
                dispatch({
                    type: 'DELETE_USER_ID_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'DELETE_USER_ID_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetDeleteUserResponse() {
    return (dispatch) => {
        dispatch({
            type: "RESET_DELETE_USER_ID"
        })
    }
}

export function updateUserStatus(url, obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(url, obj)
            if(response?.status === 200) {
                dispatch({
                    type: 'UPDATE_USER_STATUS_SINGLE_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'UPDATE_USER_STATUS_SINGLE_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {

        }
    }
}

export function resetUpdateUserStatus() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_UPDATE_USER_STATUS_RESPONSE'
        })
    }
}

export function getInvitedUsersList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.users.invitedUsersList()+url)
            if(response?.status === 200) {
                dispatch({
                    type: 'INVITED_USERS_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'INVITED_USERS_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetInvitedUsersList() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_INVITED_USERS_LIST'
        })
    }
}

export function deleteUserInvite(obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.users.deleteInviteSingle(), obj)
            if(response?.status === 200) {
                dispatch({
                    type: 'DELETE_INVITED_SUCCESS',
                    payload: response.data?.detail
                })
            } else {
                dispatch({
                    type: 'DELETE_INVITED_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetDeleteUserInvite() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_DELETE_INVITED_USERS_SUCCESS'
        })
    }
}

export function resendUserInvite(obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.users.resendInviteUser(), obj)
            if(response?.status === 200) {
                dispatch({
                    type: 'RESEND_INVITE_SUCCESS',
                    payload: response.data?.detail
                })
            } else {
                dispatch({
                    type: 'RESEND_INVITE_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetResendUserInvite() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_RESEND_INVITED_USER'
        })
    }
}

export function editUserInvite(obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.users.editUserInvite(), obj)
            if(response?.status === 200) {
                dispatch({
                    type: 'EDIT_INVITE_SUCCESS',
                    payload: response.data?.detail
                })
            } else {
                dispatch({
                    type: 'EDIT_INVITE_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetEditUserInvite() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_EDIT_INVITED_USER'
        })
    }
}